import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Container, Card, CardContent, CardActions, Button, CircularProgress,
  Typography,
  makeStyles,
  Grid,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

export default function LogoutScreen() {
  const classes = useStyles();
  const { isAuthenticated, isLoading, logout } = useAuth0();
  useEffect(() => {
    if (isAuthenticated) logout();
  }, [isAuthenticated, logout]);

  return (
    <Container className={classes.container}>
      {isAuthenticated || isLoading ? (
        <div className={classes.progressContainer}>
          <CircularProgress />
        </div>
      ) : (
        <Grid container justify="center">
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h2">Logged Out</Typography>
                <Typography>
                  You have successfully logged out.
                </Typography>
              </CardContent>
              <CardActions>
                <Button component={Link} to="/">Log In</Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(3) + 64,
    paddingBottom: theme.spacing(3),
  },
  progressContainer: {
    textAlign: 'center',
    margin: theme.spacing(3),
  },
}));
